import { jsxs, jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { dropdownItem, dropdownItemClickable, dropdownItemContent } from '../../shared/styles/item.vanilla.mjs';
import { DropdownSlot } from '../slot/Slot.mjs';
import { dropdownSubItem } from './subItem.vanilla.mjs';

const DropdownSubItem = forwardRef(
  ({ children, className: classNameFromProps, leftSlot, ...props }, forwardedRef) => {
    const className = classNames(
      dropdownItem,
      dropdownItemClickable,
      dropdownSubItem,
      classNameFromProps
    );
    return /* @__PURE__ */ jsxs(Primitive.div, { className, ref: forwardedRef, ...props, children: [
      /* @__PURE__ */ jsx(DropdownSlot, { "data-scope": "dropdown", "data-part": "sub-item-left-slot", children: leftSlot }),
      /* @__PURE__ */ jsx(
        "div",
        {
          "data-scope": "dropdown",
          "data-part": "sub-item-content",
          className: dropdownItemContent,
          children
        }
      )
    ] });
  }
);

export { DropdownSubItem };
//# sourceMappingURL=SubItem.mjs.map
